"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickMenu = StickMenu;
const React = __importStar(require("react"));
const Tabs = __importStar(require("@genesys/client-core/lib/tabs"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const user_info_1 = require("./user-info");
const index_1 = require("../main-menu/index");
function StickMenu({ dispatch, selectedTab, tabs, userName }) {
    const activateTab = (key) => dispatch(Tabs.activateTab(key));
    const removeTab = (key) => dispatch(Tabs.requestRemoveTab(key));
    return (React.createElement(Contexts.TranslateContext.Consumer, null, translate => (React.createElement(Elements.StickyMenu, { key: "menu" },
        React.createElement(Elements.TopMenu, null,
            React.createElement(index_1.MainMenu, null),
            React.createElement(user_info_1.UserInfo, { userName: userName, textTranslator: translate })),
        React.createElement(Tabs.MainTabsView, { tabs: tabs, selectedTab: selectedTab, activateTab: activateTab, removeTab: removeTab })))));
}
//# sourceMappingURL=container-component.js.map